// ProtectedRoute.js
import { Navigate, useLocation } from "react-router-dom";
import { firstAccessiblePath, hasPageAccess } from "../lib/pageAccess";

const ProtectedRoute = ({ userData, children, pageKey }) => {
  const location = useLocation();

  if (!userData?.email) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (pageKey && !hasPageAccess(userData, pageKey)) {
    return <Navigate to={firstAccessiblePath(userData)} replace />;
  }

  // Photo selections remain viewable when Drive is disconnected. The page itself
  // explains that a Google connection is required before starting a transfer.
  return children;
};

export default ProtectedRoute;
